import React from 'react';
import FullPageSuccess from 'components/FullPageSuccess';
import { POST_UNREALISED_FX_GAINS } from 'adminConstants/routes';

const PostUnrealisedFXGainsSuccess: React.FC = () => {
  return (
    <FullPageSuccess
      title={`Your unrealised FX gains/losses have been successfully posted`}
      additionalText=""
      proceedText="Post another unrealised FX gain/loss"
      proceedLink={POST_UNREALISED_FX_GAINS}
    />
  );
};

export default PostUnrealisedFXGainsSuccess;
